import { Page, PageVariant } from '@revolut-internal/ui-kit'
import { Outlet } from 'react-router-dom'

export const App = () => {
  return (
    <Page variant={PageVariant.CONTAINED}>
      <Outlet />
    </Page>
  )
}
